// extracted by mini-css-extract-plugin
module.exports = {"div":"category_list_div__35tvO","name":"category_list_name__2h-CT","nameActive":"category_list_nameActive__FZ1ze"};